import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { BaseFacade } from '../base.facade';
import { ArticleSelector } from './article.selectors';

@Injectable()
export class ArticleFacade extends BaseFacade {
	constructor(store: Store<AppState>, private articleSelector: ArticleSelector) {
		super(store);
	}

	public mediaArticle$ = this.store.select(this.articleSelector.mediaArticle);
}
